/**
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/**
 * The base colors for the Material Kit 2 React.
 * You can add new color using this file.
 * You can customized the colors for the entire Material Kit 2 React using thie file.
 */

export default {
  background: {
    default: "#F3E6F7",
  },

  text: {
    main: "#1A1A1A",
    focus: "#1A1A1A",
  },

  transparent: {
    main: "transparent",
  },

  white: {
    main: "#FFFFFF",
    focus: "#FFFFFF",
  },

  black: {
    light: "#000000",
    main: "#000000",
    focus: "#000000",
  },

  primary: {
    main: "#830095",
    focus: "#6B007F",
  },

  secondary: {
    main: "#FFD600",
    focus: "#FFC400",
  },

  info: {
    main: "#0096FF",
    focus: "#007ACC",
  },

  success: {
    main: "#39D353",
    focus: "#28A745",
  },

  warning: {
    main: "#FF9000",
    focus: "#FF6F00",
  },

  error: {
    main: "#F44336",
    focus: "#D32F2F",
  },

  light: {
    main: "#F3E6F7",
    focus: "#F3E6F7",
  },

  dark: {
    main: "#2C0036",
    focus: "#1A0020",
  },

  grey: {
    100: "#f8f9fa",
    200: "#f0f2f5",
    300: "#dee2e6",
    400: "#ced4da",
    500: "#adb5bd",
    600: "#6c757d",
    700: "#495057",
    800: "#343a40",
    900: "#212529",
  },

  gradients: {
    primary: {
      main: "#830095",
      state: "#6B007F",
    },

    secondary: {
      main: "#FFD600",
      state: "#FFC400",
    },

    info: {
      main: "#0096FF",
      state: "#007ACC",
    },

    success: {
      main: "#39D353",
      state: "#28A745",
    },

    warning: {
      main: "#FF9000",
      state: "#FF6F00",
    },

    error: {
      main: "#F44336",
      state: "#D32F2F",
    },

    light: {
      main: "#F3E6F7",
      state: "#E1BEE7",
    },

    dark: {
      main: "#2C0036",
      state: "#1A0020",
    },
  },

  socialMediaColors: {
    facebook: {
      main: "#3b5998",
      dark: "#344e86",
    },

    twitter: {
      main: "#55acee",
      dark: "#3ea1ec",
    },

    instagram: {
      main: "#125688",
      dark: "#0e456d",
    },

    linkedin: {
      main: "#0077b5",
      dark: "#00669c",
    },

    pinterest: {
      main: "#cc2127",
      dark: "#b21d22",
    },

    youtube: {
      main: "#e52d27",
      dark: "#d41f1a",
    },

    vimeo: {
      main: "#1ab7ea",
      dark: "#13a3d2",
    },

    slack: {
      main: "#3aaf85",
      dark: "#329874",
    },

    dribbble: {
      main: "#ea4c89",
      dark: "#e73177",
    },

    github: {
      main: "#24292e",
      dark: "#171a1d",
    },

    reddit: {
      main: "#ff4500",
      dark: "#e03d00",
    },

    tumblr: {
      main: "#35465c",
      dark: "#2a3749",
    },
  },

  badgeColors: {
    primary: {
      background: "#f8b3ca",
      text: "#cc084b",
    },

    secondary: {
      background: "#d7d9e1",
      text: "#6c757d",
    },

    info: {
      background: "#aecef7",
      text: "#095bc6",
    },

    success: {
      background: "#bce2be",
      text: "#339537",
    },

    warning: {
      background: "#ffd59f",
      text: "#c87000",
    },

    error: {
      background: "#fcd3d0",
      text: "#f61200",
    },

    light: {
      background: "#ffffff",
      text: "#c7d3de",
    },

    dark: {
      background: "#8097bf",
      text: "#1e2e4a",
    },
  },

  coloredShadows: {
    primary: "#e91e62",
    secondary: "#110e0e",
    info: "#00bbd4",
    success: "#4caf4f",
    warning: "#ff9900",
    error: "#f44336",
    light: "#adb5bd",
    dark: "#404040",
  },

  inputBorderColor: "#d2d6da",

  tabs: {
    indicator: { boxShadow: "#ddd" },
  },
};
